/* DACOBI Black Friday 2026 sign-up page: live state, countdown, mystery cards, sign-up form, phone sticky bar.
   Loaded by every dacobi-bf26-* section; runs once. */
(function () {
  if (window.__bf26) return;
  window.__bf26 = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  ready(function () {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-bf26]'));
    if (!roots.length) return;
    var START = parseInt(roots[0].getAttribute('data-bf-start'), 10) * 1000;
    var END = parseInt(roots[0].getAttribute('data-bf-end'), 10) * 1000;

    /* ---------- state + countdown (fixed dates, never restarts) ---------- */
    var counters = Array.prototype.slice.call(document.querySelectorAll('[data-bf-count]'));
    var state = '';
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function stateAt(t) { return t >= END ? 'ended' : t >= START ? 'live' : 'pre'; }
    function tick() {
      var now = Date.now();
      var s = stateAt(now);
      if (s !== state) {
        state = s;
        roots.forEach(function (r) { r.setAttribute('data-bf-state', s); });
        document.dispatchEvent(new CustomEvent('bf26:state', { detail: s }));
      }
      var target = s === 'pre' ? START : END;
      var left = Math.max(0, Math.floor((target - now) / 1000));
      var d = Math.floor(left / 86400), h = Math.floor((left % 86400) / 3600), m = Math.floor((left % 3600) / 60), sec = left % 60;
      counters.forEach(function (c) {
        var map = { d: d, h: h, m: m, s: sec };
        c.querySelectorAll('[data-u]').forEach(function (el) {
          var v = pad(map[el.getAttribute('data-u')]);
          if (el.textContent !== v) el.textContent = v;
        });
      });
      if (s === 'ended') return;
      setTimeout(tick, 1000 - (now % 1000) + 5);
    }
    tick();

    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- the one orchestrated moment: hero intro (CSS does the motion; nothing starts hidden) ---------- */
    var hero = document.querySelector('[data-bf-hero]');
    if (hero && !calm) hero.classList.add('is-intro');

    /* ---------- scroll reveal + strip, via IntersectionObserver ---------- */
    if ('IntersectionObserver' in window && !calm) {
      var rv = Array.prototype.slice.call(document.querySelectorAll('.bf26 [data-rv], [data-bf-strip]'));
      if (rv.length) {
        var vh = window.innerHeight || 800;
        rv.forEach(function (el) { if (el.getBoundingClientRect().top < vh * 0.95) el.classList.add('is-in'); });
        document.documentElement.classList.add('bf-rv-on');
        var rio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); rio.unobserve(en.target); } });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
        rv.forEach(function (el) { if (!el.classList.contains('is-in')) rio.observe(el); });
      }
    }

    /* ---------- engraving carousel (native scroll-snap; buttons + counter) ---------- */
    document.querySelectorAll('[data-bf-car]').forEach(function (car) {
      var track = car.querySelector('[data-bf-car-track]');
      var slides = track ? Array.prototype.slice.call(track.children) : [];
      var prev = car.querySelector('[data-bf-car-prev]');
      var next = car.querySelector('[data-bf-car-next]');
      var out = car.querySelector('[data-bf-car-i]');
      if (!track || !slides.length) return;
      var cur = 0;
      function set(i) {
        cur = i;
        if (out) out.textContent = String(i + 1);
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= slides.length - 1;
      }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: calm ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });
      if ('IntersectionObserver' in window) {
        var cio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) set(slides.indexOf(en.target)); });
        }, { root: track, threshold: 0.6 });
        slides.forEach(function (sl) { cio.observe(sl); });
      }
      set(0);
    });

    /* ---------- mystery cards ---------- */
    document.querySelectorAll('[data-bf-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        card.setAttribute('aria-pressed', card.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      });
    });

    /* ---------- success popup (native modal dialog) ---------- */
    var dlg = document.querySelector('[data-bf-dlg]');
    var dlgBack = null;
    function openDlg(wrap) {
      if (!dlg || typeof dlg.showModal !== 'function' || dlg.open) return;
      dlgBack = document.activeElement;
      try { dlg.showModal(); } catch (e) { return; }
      /* the popup carries the inbox tip now, so the in-form copy of it can go */
      document.querySelectorAll('[data-bf-ok-inbox]').forEach(function (el) { el.hidden = true; });
      var first = dlg.querySelector('[data-bf-dlg-copy]');
      if (first) first.focus();
      document.dispatchEvent(new CustomEvent('bf26:dlg-open'));
    }
    if (dlg) {
      var live = dlg.querySelector('[data-bf-dlg-live]');
      dlg.addEventListener('close', function () {
        var back = dlgBack && document.contains(dlgBack) ? dlgBack : document.querySelector('[data-bf-ok]:not([hidden])');
        if (back && back.focus) back.focus({ preventScroll: true });
      });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      dlg.querySelectorAll('[data-bf-dlg-close]').forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
      var copyBtn = dlg.querySelector('[data-bf-dlg-copy]');
      var addr = dlg.querySelector('[data-bf-dlg-addr]');
      if (copyBtn && addr) copyBtn.addEventListener('click', function () {
        var text = addr.textContent.trim();
        function selectIt() {
          var r = document.createRange(); r.selectNodeContents(addr);
          var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
        }
        function ok() { copyBtn.textContent = copyBtn.getAttribute('data-done'); if (live) live.textContent = copyBtn.getAttribute('data-done'); }
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(text).then(ok, function () { selectIt(); });
        } else {
          selectIt();
          try { if (document.execCommand('copy')) ok(); } catch (e) {}
        }
      });
    }

    /* ---------- sign-up form ---------- */
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    document.querySelectorAll('[data-bf-form]').forEach(function (wrap) {
      var form = wrap.tagName === 'FORM' ? wrap : wrap.querySelector('form');
      if (!form) return;
      var input = form.querySelector('input[type="email"]');
      var btn = form.querySelector('button[type="submit"]');
      var err = form.querySelector('[data-bf-err]');
      var ok = form.querySelector('[data-bf-ok]');
      var native = false;
      var labelIdle = btn ? btn.textContent : '';

      function showErr(msg) {
        if (err) err.textContent = msg || '';
        if (input) {
          if (msg) input.setAttribute('aria-invalid', 'true');
          else input.removeAttribute('aria-invalid');
        }
      }
      function done() {
        wrap.classList.add('is-done');
        if (ok) { ok.hidden = false; ok.focus({ preventScroll: true }); }
        document.querySelectorAll('[data-bf-form]').forEach(function (other) {
          if (other === wrap) return;
          other.classList.add('is-done');
          var o = other.querySelector('[data-bf-ok]');
          if (o) o.hidden = false;
        });
        document.dispatchEvent(new CustomEvent('bf26:signed-up'));
        openDlg(wrap);
      }
      /* DATA Reshape lead_created: once, after Klaviyo or Shopify accepted the e-mail (never on click).
         One push; Reshape fans it out to GA4 generate_lead, Google Ads, Meta Lead and TikTok SubmitForm,
         so no gtag/fbq/ttq here. event.id = 'bf26_' + SHA-256(lowercased e-mail minus its last 3 chars),
         same rule as the Tsuchime page, so a re-submit dedupes. Value 0 (the value comes with the purchase). */
      function pushLead(email) {
        var send = function (id) {
          try {
            window.reshape = window.reshape || [];
            window.reshape.push({
              event: {
                name: 'lead_created',
                value: 0,
                currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
                id: id,
                properties: {
                  lead_source: 'black_friday_2026',
                  form_name: 'black_friday_2026_early_access',
                  placement: /hero/.test(form.id || '') ? 'hero' : 'closing'
                }
              },
              context: { url: window.location.href, page_type: 'landing', environment: 'prod' },
              user: { email: email, properties: { black_friday_2026_early_access: true } }
            });
          } catch (e) {}
        };
        var seed = email.toLowerCase();
        seed = seed.length > 3 ? seed.slice(0, -3) : seed;
        if (window.crypto && window.crypto.subtle && window.TextEncoder) {
          window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(seed)).then(function (buf) {
            send('bf26_' + Array.from(new Uint8Array(buf)).map(function (b) { return b.toString(16).padStart(2, '0'); }).join(''));
          }).catch(function () { send('bf26_' + Date.now().toString(36)); });
        } else {
          send('bf26_' + Date.now().toString(36));
        }
      }
      function busy(on) {
        if (!btn) return;
        btn.disabled = on;
        btn.textContent = on ? (btn.getAttribute('data-busy') || labelIdle) : labelIdle;
      }
      if (input) input.addEventListener('input', function () { if (input.getAttribute('aria-invalid')) showErr(''); });

      /* run from one window capture-phase listener (below), so no other submit handler sees our forms:
         Shopify's storefront hCaptcha hook would otherwise post the form natively after our fetch and reload the page */
      wrap.__bfSubmit = function (e) {
        if (native) return;
        var email = input ? input.value.trim() : '';
        if (!EMAIL_RE.test(email)) {
          e.preventDefault();
          showErr(wrap.getAttribute('data-msg-invalid'));
          if (input) input.focus();
          return;
        }
        e.preventDefault();
        showErr('');
        busy(true);
        /* if the browser ever has to post the form itself, come back to this exact URL (keeps ?view / preview params) */
        var rt = form.querySelector('input[name="return_to"]');
        if (!rt) { rt = document.createElement('input'); rt.type = 'hidden'; rt.name = 'return_to'; form.appendChild(rt); }
        rt.value = location.pathname + location.search;

        /* 1) Klaviyo list (main path, single opt-in; the welcome/confirmation flow hangs off the list)
           2) Shopify customer form (backup record, tags black-friday-2026 + bf-early-access)
           Success (and the popup) when either one is accepted; if both fail, the browser posts the form normally. */
        var kList = wrap.getAttribute('data-klaviyo-list');
        var kCompany = wrap.getAttribute('data-klaviyo-company');
        var klaviyo = Promise.resolve('off');
        if (kList && kCompany) {
          klaviyo = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(kCompany), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
            body: JSON.stringify({ data: { type: 'subscription', attributes: {
              custom_source: wrap.getAttribute('data-klaviyo-source') || 'Black Friday 2026',
              /* revision 2024-10-15 rejects profile.subscriptions here (400 "not a valid field");
                 a client subscription to the list is itself the marketing consent */
              profile: { data: { type: 'profile', attributes: { email: email } } }
            }, relationships: { list: { data: { type: 'list', id: kList } } } } })
          }).then(function (res) { return res.ok ? 'ok' : 'fail'; }, function () { return 'fail'; });
        }

        var shopify = fetch(form.action, {
          method: 'POST', body: new FormData(form), credentials: 'same-origin', redirect: 'follow',
          headers: { Accept: 'text/html' }
        }).then(function (res) {
          var url = res.url || '';
          if (url.indexOf('/challenge') !== -1) return 'challenge';
          /* Shopify answers a good post with a redirect back to the page; any 2xx that is not the captcha counts */
          return res.ok ? 'ok' : 'retry';
        }).catch(function () { return 'retry'; });

        Promise.all([klaviyo, shopify]).then(function (r) {
          busy(false);
          wrap.setAttribute('data-bf-result', 'klaviyo:' + r[0] + ' shopify:' + r[1]);
          if (r[0] === 'ok' || r[1] === 'ok') { pushLead(email); return done(); }
          /* neither accepted it (captcha or a server-side error): let the browser post the form the normal way */
          native = true;
          form.submit();
        });
      };
    });
    window.addEventListener('submit', function (e) {
      var t = e.target;
      var w = t && t.closest ? t.closest('[data-bf-form]') : null;
      if (!w || !w.__bfSubmit) return;
      e.stopImmediatePropagation();
      w.__bfSubmit(e);
    }, true);

    var posted = document.querySelector('[data-bf-form] [data-bf-ok]:not([hidden])');
    if (posted) openDlg(posted.closest('[data-bf-form]'));

    /* ---------- phone sticky bar ---------- */
    var sticky = document.querySelector('[data-bf-sticky]');
    if (sticky) {
      var jump = sticky.querySelector('a[href="#bf26-signup"]');
      var target = document.getElementById('bf26-signup');
      if (jump && target) jump.addEventListener('click', function (e) {
        var field = target.querySelector('input[type="email"]');
        if (!field) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });
        field.focus({ preventScroll: true });
      });
    }
    if (sticky && 'IntersectionObserver' in window) {
      var watched = Array.prototype.slice.call(document.querySelectorAll('[data-bf-sticky-hide]'));
      var visible = new Set();
      var signed = !!document.querySelector('[data-bf-form] [data-bf-ok]:not([hidden])');
      var seen = false;
      var kb = false;
      var phone = window.matchMedia('(max-width: 749px)');
      function update() {
        var dlgOpen = !!(dlg && dlg.open);
        var on = seen && phone.matches && !kb && !dlgOpen && !(signed && state === 'pre') && state !== 'ended' && visible.size === 0;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        sticky.querySelectorAll('a,button').forEach(function (el) { el.tabIndex = on ? 0 : -1; });
        liftChat(on);
      }
      /* the chat launcher pins itself with an inline !important bottom; lift it above the bar while the bar shows */
      var chatOrig = null;
      function liftChat(on) {
        var bub = document.querySelector('.woot-widget-bubble');
        if (!bub || window.matchMedia('(min-width: 750px)').matches) return;
        if (chatOrig === null) chatOrig = bub.style.getPropertyValue('bottom') || '';
        if (on) bub.style.setProperty('bottom', 'calc(88px + env(safe-area-inset-bottom))', 'important');
        else if (chatOrig) bub.style.setProperty('bottom', chatOrig, 'important');
        else bub.style.removeProperty('bottom');
      }
      if ('MutationObserver' in window) {
        var mo = new MutationObserver(function () {
          if (document.querySelector('.woot-widget-bubble')) { mo.disconnect(); update(); }
        });
        mo.observe(document.body, { childList: true, subtree: true });
        setTimeout(function () { mo.disconnect(); }, 30000);
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { visible.add(en.target); return; }
          visible.delete(en.target);
          /* the form scrolled away: let go of its field so nothing keeps the bar (or the keyboard) pinned */
          var a = document.activeElement;
          if (a && en.target.contains(a) && a.matches && a.matches('input, textarea')) a.blur();
        });
        kbCheck();
        seen = true;
        update();
      }, { threshold: 0 });
      watched.forEach(function (el) { io.observe(el); });
      document.addEventListener('bf26:state', update);
      document.addEventListener('bf26:signed-up', function () { signed = true; update(); });
      /* hide only while the on-screen keyboard is really up: the visual viewport is >150 px shorter than the layout one */
      function kbCheck() {
        var vv = window.visualViewport;
        var up = !!vv && (window.innerHeight - vv.height > 150);
        if (up !== kb) { kb = up; update(); }
      }
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', kbCheck);
        window.visualViewport.addEventListener('scroll', kbCheck);
      }
      if (phone.addEventListener) phone.addEventListener('change', update);
      if (dlg) { dlg.addEventListener('close', update); }
      document.addEventListener('bf26:dlg-open', update);
    }
  });
})();
